import { createSlice } from '@reduxjs/toolkit';
import { message } from 'antd';

import { apiReducerBuilder } from 'utils';

import { getQRCode, verify2FA } from './actions';

type QR = {
	tfa_qr_uri: string;
	tfa_secret: string;
};

interface Verify2FA {
	qrCode: QR;
	step: number;
	status: string;
	statusQRCode: string;
}

const initialState = { qrCode: {}, step: 1 } as Verify2FA;

const verify2FASlice = createSlice({
	name: 'verify2FA',
	initialState,
	reducers: {
		setVerify2FAStep(state, action) {
			state.step = action.payload;
		},
		closeVerify() {
			return initialState;
		},
	},
	extraReducers: (builder) => {
		builder.addCase(getQRCode.pending, (state, action) => {
			const { meta } = action;
			state.status = meta.requestStatus;
			state.statusQRCode = meta.requestStatus;
		});

		builder.addCase(getQRCode.fulfilled, (state: any, action) => {
			const { payload, meta } = action;
			state.status = meta.requestStatus;
			state.statusQRCode = meta.requestStatus;
			state.qrCode = payload;
		});

		builder.addCase(getQRCode.rejected, (state: any, action) => {
			const { meta, error } = action;
			state.status = meta.requestStatus;
			state.statusQRCode = meta.requestStatus;
			message.warn(error.message);
			state.qrCode = {};
		});

		apiReducerBuilder(builder, verify2FA, (state, action) => {
			const { meta } = action;
			state.status = meta.requestStatus;
			state.step = 3;
		});
	},
});

export const { setVerify2FAStep, closeVerify } = verify2FASlice.actions;

export default verify2FASlice.reducer;
